var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list-box"},[(_vm.isEmpty)?_c('empty',{attrs:{"emptyText":"暂无数据"}}):_c('div',{staticClass:"product-list"},_vm._l((_vm.productList),function(item){return _c('product-list-item',{key:item.visa_product_id,attrs:{"product":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }